import { render, staticRenderFns } from "./BusinessCardPanel.vue?vue&type=template&id=2ac1fdea&scoped=true&lang=pug&"
import script from "./BusinessCardPanel.vue?vue&type=script&lang=js&"
export * from "./BusinessCardPanel.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCardPanel.vue?vue&type=style&index=0&id=2ac1fdea&prod&lang=sass&scoped=true&"
import style1 from "./BusinessCardPanel.vue?vue&type=style&index=1&id=2ac1fdea&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac1fdea",
  null
  
)

/* custom blocks */
import block0 from "./BusinessCardPanel.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports